import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02f3e49c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-block-wrapper" }
const _hoisted_2 = { class: "container-content-friends" }
const _hoisted_3 = { class: "friends-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Friends", -1))
const _hoisted_5 = {
  key: 1,
  class: "container-friends"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Add Friends", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!
  const _component_BlockProfileFriendList = _resolveComponent("BlockProfileFriendList")!
  const _component_PendingFriends = _resolveComponent("PendingFriends")!
  const _component_AddFriendsModalContent = _resolveComponent("AddFriendsModalContent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_PlusIcon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalOpen = true))
        })
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.friends.length > 0)
              ? (_openBlock(), _createBlock(_component_BlockProfileFriendList, {
                  onOnFriendMutated: _ctx.start,
                  friends: _ctx.friends,
                  "horizontal-slide": true,
                  key: _ctx.friends
                }, null, 8, ["onOnFriendMutated", "friends"]))
              : _createCommentVNode("", true),
            (
            _ctx.pendingSentRequests.length > 0 || _ctx.pendingRequestRequests.length > 0
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_PendingFriends, {
                    onOnFriendMutated: _ctx.start,
                    requests: _ctx.pendingRequestRequests
                  }, null, 8, ["onOnFriendMutated", "requests"]),
                  _createVNode(_component_PendingFriends, {
                    onOnFriendMutated: _ctx.start,
                    from: false,
                    requests: _ctx.pendingSentRequests
                  }, null, 8, ["onOnFriendMutated", "requests"])
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(_component_Modal, {
      onOnCloseClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalOpen = false)),
      "is-open": _ctx.modalOpen
    }, {
      default: _withCtx(() => [
        _hoisted_7,
        _createVNode(_component_AddFriendsModalContent, { onOnRequestSent: _ctx.start }, null, 8, ["onOnRequestSent"])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}